import { Typography, Divider } from "@mui/material";
import { useGetRechnungsDublette } from "../../client/hooks";
import { useEffect, useState } from "react";

export default function DublettenCheck({
  rechnungId,
  lieferantenId,
  rechnungsnummer,
}: {
  rechnungId: string;
  lieferantenId: string;
  rechnungsnummer: string;
}) {
  const checkDublette = useGetRechnungsDublette();
  const [isDublette, setIsDublette] = useState<boolean>(false);

  useEffect(() => {
    const fetchDublette = async () => {
      if (rechnungsnummer !== undefined && lieferantenId !== undefined) {
        let dublette = await checkDublette(rechnungId, {
          rechnungsNummer: rechnungsnummer ? rechnungsnummer : "",
          lieferantenId: lieferantenId ? lieferantenId : "",
        });
        setIsDublette(dublette.isDublette);
      }
    };
    fetchDublette();
  }, [rechnungsnummer, lieferantenId]);

  return (
    <>
      {isDublette ? (
        <>
          <Divider />
          <Typography variant="h5" color={"error"}>
            Diese Rechnungsnummer ist bereits bekannt
          </Typography>
          <Divider />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
